import styled from 'styled-components'

export const ClientSettingsContainer = styled.div`
  margin-top: 50px;
  padding-left: 30px;
  padding-right: 48px;
`
export const ClientSettingsRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ClientSettingsItem = styled.div`
  width: 100%;
  margin-right: 20px;
`
